import React from 'react';
import { IProps } from './interfaces';

const KrFighting: React.FC<IProps> = ({
  size = 32,
  color = '#FF6900',
  className,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5206_2673)">
        <path
          d="M27.5 14.11C27.29 12.87 26.65 11.88 25.63 11.12C25.97 10.3 26.29 9.11001 26.12 5.54001C25.87 0.240007 24.94 0.220007 16.02 6.9607e-06C11.57 -0.109993 8.86 0.190007 7.32 2.03001C5.86 3.78001 5.72 6.65001 5.61 11.2C5.44 18.56 8.12 23.21 9.31 24.9C9.31 24.94 9.28 24.98 9.28 25.03V31.05C9.28 31.55 9.68 31.95 10.18 31.95H22.01C22.51 31.95 22.91 31.55 22.91 31.05V25.03C22.91 25.03 22.89 24.96 22.89 24.92C24.4 23.07 28.17 17.98 27.51 14.1L27.5 14.11ZM21.21 24.14H19.2C19.34 23.57 19.46 22.73 19.56 21.47C19.59 21.14 19.34 20.85 19.01 20.83C18.68 20.81 18.39 21.05 18.37 21.38C18.29 22.43 18.12 23.68 17.97 24.14H14.57C14.3 23.26 13.89 21.4 13.6 19.77C13.54 19.44 13.23 19.23 12.9 19.29C12.57 19.35 12.36 19.66 12.42 19.99C12.78 22.02 13.07 23.31 13.32 24.15H10.99C10.29 23.21 8.24 20.06 7.61 14.92C8.72 16.07 10.27 16.79 12 16.79H15.45C15.76 16.79 16 16.56 16.04 16.26C16.56 16.88 17.32 17.42 18.44 17.71C18.92 17.84 19.41 17.55 19.54 17.07C19.67 16.59 19.38 16.1 18.9 15.97C16.73 15.4 16.88 13.57 16.9 13.39C17.01 12.74 17.29 12.29 17.8 11.99C19.45 11 22.88 11.83 24.16 12.26C25.07 12.78 25.58 13.48 25.74 14.41C26.26 17.46 22.87 22.2 21.22 24.14H21.21ZM24.32 5.62001C24.46 8.61001 24.24 9.69001 24 10.33C23.66 10.23 23.24 10.13 22.76 10.03C22.83 9.70001 22.86 9.36001 22.86 9.01001V2.25001C23.09 2.31001 23.29 2.37001 23.45 2.45001C24.1 2.77001 24.21 3.38001 24.32 5.62001ZM16 1.81001C18.55 1.87001 20.4 1.91001 21.68 2.05001C21.68 2.06001 21.68 2.07001 21.68 2.09001V9.01001C21.68 9.29001 21.65 9.56001 21.59 9.83001C20.03 9.63001 18.21 9.65001 16.88 10.44C15.99 10.97 15.42 11.81 15.18 12.89H14.54C12.37 12.89 10.61 11.15 10.61 9.01001V2.13001C11.78 1.84001 13.49 1.74001 16.01 1.80001L16 1.81001ZM8.7 3.19001C8.89 2.96001 9.12 2.77001 9.4 2.60001V9.01001C9.4 11.81 11.7 14.09 14.53 14.09H15.11C15.17 14.57 15.31 15.1 15.59 15.62C15.54 15.61 15.49 15.59 15.44 15.59H11.99C9.9 15.59 8.13 14.29 7.42 12.48C7.42 12.08 7.4 11.68 7.42 11.26C7.52 7.09001 7.65 4.47001 8.71 3.20001L8.7 3.19001ZM21.11 30.15H11.08V25.94H21.11V30.15Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_5206_2673">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default KrFighting;
